import { useState, useEffect } from 'react';
import { ArrowRight, Play } from 'lucide-react';
import styles from './Hero.module.css';

interface HeroProps {
  title?: string;
  tagline?: string;
  primaryCta?: string;
  secondaryCta?: string;
}

const Hero = ({
  title = 'COSMOS HORIZON',
  tagline = 'Explore the Unknown. Conquer the Galaxy.',
  primaryCta = 'Play Now',
  secondaryCta = 'Learn More'
}: HeroProps) => {
  const [scrollY, setScrollY] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handlePrimaryClick = () => {
    // Handle primary CTA - e.g., open download modal or redirect to store
    console.log('Primary CTA clicked');
  };

  const handleSecondaryClick = () => {
    // Scroll to features section
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className={styles.hero}
      style={{
        transform: `translateY(${scrollY * 0.5}px)`
      }}
    >
      <div className={styles.background}>
        <div className={styles.backgroundImage} />
        <div className={styles.overlay} />
        <div className={styles.stars} />
      </div>

      <div className={styles.container}>
        <div
          className={`${styles.content} ${isLoaded ? styles.loaded : ''}`}
        >
          <h1 className={styles.title}>
            <span className={styles.titleText}>{title}</span>
          </h1>

          <p className={styles.tagline}>
            {tagline}
          </p>

          <div className={styles.ctaContainer}>
            <button
              className={`${styles.btn} ${styles.btnPrimary}`}
              onClick={handlePrimaryClick}
              aria-label="Start playing Cosmos Horizon now"
            >
              <Play size={20} className={styles.btnIcon} />
              {primaryCta}
            </button>

            <button
              className={`${styles.btn} ${styles.btnSecondary}`}
              onClick={handleSecondaryClick}
              aria-label="Learn more about Cosmos Horizon features"
            >
              {secondaryCta}
              <ArrowRight size={20} className={styles.btnIcon} />
            </button>
          </div>

          <div className={styles.scrollIndicator}>
            <span className={styles.scrollText}>Scroll to Explore</span>
            <div className={styles.scrollLine} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
